﻿import { normalizeToolKey } from './workbench-domain.js';

/**
 * execute-workbench-tool.js
 * Domain use case that normalises requests, sanitises payloads, and submits tools.
 */
export function createExecuteWorkbenchTool({ submit } = {}) {
  if (typeof submit !== 'function') {
    throw new Error('submit is required');
  }

  return async function executeWorkbenchTool({
    toolKey,
    teamId = null,
    teamName = null,
    payload = {},
    attachments = [],
  } = {}) {
    const normalizedTool = normalizeToolKey(toolKey);
    if (!normalizedTool) {
      throw new Error('toolKey is required');
    }

    const sanitisedPayload = payload && typeof payload === 'object' ? payload : {};
    const files = Array.isArray(attachments) ? attachments : [];

    const response = await submit({
      tool: normalizedTool,
      teamId,
      teamName,
      payload: sanitisedPayload,
      attachments: files,
    });

    return {
      response,
      context: { tool: normalizedTool },
      source: 'service',
    };
  };
}

if (typeof window !== 'undefined') {
  window.AgileProDomain = window.AgileProDomain || {};
  window.AgileProDomain.workbench = window.AgileProDomain.workbench || {};
  window.AgileProDomain.workbench.createExecuteWorkbenchTool = createExecuteWorkbenchTool;
}
